// bgColor and fontColor passed as a prop to the Component
// should be respresentation of colors used in theme.js and be included there
//
// <Button bgColor="blue_500" fontColor="white"
import styled from "styled-components"

interface ButtonProps {
  /** Small button size (decreases padding) */
  small?: boolean
  /** Should button be full width */
  fullWidth?: boolean
  width?: string
  /** Custom border color for the button, defaults to gray */
  borderColor?: string
  /** Custom background color for the button, defaults to dark blue */
  bgColor?: string
  /** Custom font color for the button, defaults to white */
  fontColor?: string
  disabled?: boolean
}

const Button = styled.button<ButtonProps>`
  box-shadow: ${({ theme }) => theme.shadow_base};
  border-radius: 4px;
  padding: ${({ theme, small }) =>
    small
      ? `${theme.spacing[2]} ${theme.spacing[3]}`
      : `${theme.spacing[3]} ${theme.spacing[4]}`};
  letter-spacing: 0.8px;
  text-align: center;
  font-size: 14px;
  line-height: 150%;
  border: ${({ theme, borderColor }) =>
    borderColor === "none"
      ? "none"
      : `1px solid ${theme[borderColor] || borderColor || theme.gray_200}`};
  background-color: ${({ bgColor, disabled, theme }) =>
    // If bgColor can be found in theme, use it
    // If bgColor is a color HEX, use it
    // If none bgColor is provided, use default
    disabled ? theme.gray_400 : theme[bgColor] || bgColor || theme.blue_900};
  color: ${({ fontColor, theme, disabled }) =>
    disabled ? theme.blue_700 : fontColor ? theme[fontColor] : theme.white};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  width: ${({ width, fullWidth, theme }) =>
    fullWidth ? "100%" : width ? theme.width[width] : "auto"};
`

export default Button
